module.exports = __webpack_public_path__ + "static/3dPrinting-b1332b100c2d7010768e77700eedd35f.jpg";